import { render, staticRenderFns } from "./PrivacyPolicyHeader.vue?vue&type=template&id=ba65abda&scoped=true&"
import script from "./PrivacyPolicyHeader.vue?vue&type=script&lang=ts&"
export * from "./PrivacyPolicyHeader.vue?vue&type=script&lang=ts&"
import style0 from "./PrivacyPolicyHeader.vue?vue&type=style&index=0&id=ba65abda&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba65abda",
  null
  
)

export default component.exports